import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import Logo from "@/components/Logo";
import { CheckCircle2, XCircle, Download } from "lucide-react";

export default function CertificateValidate() {
  const { code } = useParams();
  const [cert, setCert] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    axios.get(`${API}/certificates/${code}`)
      .then((r) => setCert(r.data))
      .catch((e) => setError(e.response?.data?.detail || "Certificado não encontrado"));
  }, [code]);

  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-[var(--unigr-border)] py-6 px-6 lg:px-10">
        <Logo />
      </header>
      <main className="max-w-3xl mx-auto px-6 py-16">
        <div className="eyebrow mb-2">Validação pública</div>
        <h1 className="font-display text-3xl md:text-4xl font-extrabold">Validação de certificado</h1>
        <div className="font-mono text-sm text-slate-500 mt-1">Código: {code}</div>

        {error && (
          <Card className="mt-8 border-rose-200 bg-rose-50">
            <CardContent className="p-6 flex items-center gap-3 text-rose-700">
              <XCircle className="w-6 h-6" />
              <div>
                <div className="font-bold">Não foi possível validar</div>
                <div className="text-sm">{error}</div>
              </div>
            </CardContent>
          </Card>
        )}

        {cert && (
          <Card className="mt-8 border-emerald-200" data-testid="validate-success">
            <CardContent className="p-8">
              <div className="flex items-center gap-3 text-emerald-700 mb-6">
                <CheckCircle2 className="w-7 h-7" />
                <div className="font-display font-bold text-xl">Certificado autêntico</div>
              </div>
              <Field label="Colaborador" value={cert.user_name} />
              <Field label="Empresa" value={cert.company_name} />
              <Field label="Curso" value={cert.course_title} />
              <Field label="Carga horária" value={`${cert.duration_hours}h`} />
              <Field label="Emitido em" value={(cert.issued_at || "").slice(0, 10)} />
              <Field label="Nota final" value={`${cert.score}%`} />
              <a href={`${API}/certificates/${code}/pdf`} target="_blank" rel="noopener noreferrer">
                <Button className="btn-navy mt-6" data-testid="validate-download-btn">
                  <Download className="w-4 h-4 mr-2" />Baixar certificado em PDF
                </Button>
              </a>
            </CardContent>
          </Card>
        )}
      </main>
    </div>
  );
}

function Field({ label, value }) {
  return (
    <div className="grid grid-cols-3 gap-4 py-3 border-b border-[var(--unigr-border)] last:border-b-0">
      <div className="text-sm text-slate-500">{label}</div>
      <div className="col-span-2 font-medium">{value || "—"}</div>
    </div>
  );
}
